export default __webpack_public_path__ + "static/img_2_2-2b05dec7463dd259a4aac48135b1f94f.jpg";